import React from "react";
import { Link as RouterLink, withRouter } from "react-router-dom";
import i18n from "i18next";
import { connect } from "react-redux";
import { api } from "@/utils/api";

import config from "@/utils/config";
import {
  parse,
  isMiniSize as isMiniSizeMethod,
  debounce,
  preventClickEvent,
} from "@/utils";
import {
  eventEnum,
  authStateEnum,
  modeEnum,
  existStatusEnum,
  // 課金-ADD-START
  applicationBillingPlanCodeEnum,
  // 課金-ADD-END
} from "@/utils/enum";
import url from "@/utils/url";
import SearchBar from "@/react-components/SearchBar";

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isMiniSize: false,
      paymentServiceStarted: false
    };

    this.resizeDebounce = debounce(this.resize);
  }

  componentDidMount() {
    this.disableEvent();
    this.resize();
    window.addEventListener("resize", this.resizeDebounce);
    this.fetchTime();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeDebounce);
    this.resizeDebounce.cancel();
  }

  fetchTime = () => {   
    const serviceStartDate = new Date(i18n.t("TCCs0018_lp_payment_service_start_datetime"));
    api.common
      .getTime()
      .then((response) => {
        const paymentServiceStarted = new Date(response) >= serviceStartDate;
        this.setState({ paymentServiceStarted });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  resize = () => {
    this.setState({
      isMiniSize: isMiniSizeMethod(),
    });
  };

  // ee mode disable click event
  disableEvent = () => {
    const { mode } = this.props;
    if (mode === modeEnum.pageEditing || mode === modeEnum.preview) {
      preventClickEvent("header");
    }
  };

  // サーチ
  handleSearch = (keyWord) => {
    const { isMiniSize } = this.state;
    const {
      history: { push },
    } = this.props;
    if (isMiniSize) {
      push({
        pathname: url.search,
      });
    } else {
      push({
        pathname: url.search,
        state: { keyWord },
      });
    }
  };

  // ログアウト
  logout = () => {
    config.eventEmitter.emitEvent(eventEnum.logout);
  };

  // レフトメニュー
  leftMenuClick = () => {
    config.eventEmitter.emitEvent(eventEnum.toggleMenu);
  };

  // お知らせ
  mailClick = () => {
    const {
      history: { push },
    } = this.props;
    push(url.information);
  };

  render() {
    const {
      paymentServiceStarted,
    } = this.state;
    const {
      headerInfo,
      authState,
      // 課金-ADD-START
      contractInfo,
      // 課金-ADD-END
      informationBadgeStatus,
      title,
      location: { search, pathname },
    } = this.props;
    return (
      <div>
        <header id="header" className="header block-when-pc">
          <SearchBar
            keyword={parse("keyword", search)}
            search={this.handleSearch}
          />
          <div className="flex-row-vertical-center">
            <button className="header-mail" onClick={this.mailClick}>
              <img
                className=""
                src={require("@/assets/images/mail-icon.svg")}
                alt=""
              />
              {informationBadgeStatus === existStatusEnum.existence ? (
                <span className="header-mail-badge" />
              ) : null}
            </button>
            {/* 課金-ADD-START */}
            {paymentServiceStarted && contractInfo?.corporationBmServiceAvailabilityFlag ===
              existStatusEnum.existence && (
              <div className="header-payment">
                <img
                  className=""
                  src={
                    contractInfo?.applicationBillingPlanCode ===
                    applicationBillingPlanCodeEnum.payment
                      ? require("@/assets/images/plan-payment.svg")
                      : require("@/assets/images/plan-free.svg")
                  }
                  alt=""
                />
              </div>
            )}
            {/* 課金-ADD-END */}
            <div className="flex-row-vertical-center header-account">
              <div
                className="flex-row-vertical-center full-height"
                tabIndex="0"
              >
                <img
                  className="account-avatar"
                  src={require("@/assets/images/dummy-avatar.svg")}
                  alt=""
                />
                <div>
                  <div className="account-name">
                    {`${headerInfo?.companyName || ""}`}
                  </div>
                  <div className="account-name">
                    {`${headerInfo?.userName || ""}`}
                  </div>
                </div>
                <img
                  className="account-arrow-img"
                  src={require("@/assets/images/ic_account_arrow_down.svg")}
                  alt=""
                />
              </div>
              <div className="account-menu-div">
                <div className="account-menu">
                  <RouterLink to={url.settingsCorpProfile}>
                    {i18n.t("TCMS01002_companyProfile")}
                  </RouterLink>
                  <RouterLink to={url.settingsUserProfile}>
                    {i18n.t("TCMS01002_userProfile")}
                  </RouterLink>
                  {authState === authStateEnum.auth0 && (
                    <button
                      className="logout-button"
                      onClick={this.logout}
                      tabIndex="0"
                    >
                      {i18n.t("TCMS01002_logout")}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </header>
        {config.isTest && (
          <div className="sp-top-test-bar block-when-sp">テスト環境</div>
        )}
        <header className="flex-row-center sp-header flex-when-sp">
          <div className="flex-row-vertical-center sp-menu-left">
            <div
              className="flex-row-center sp-menu-hamburger"
              onClick={this.leftMenuClick}
              tabIndex="0"
            >
              <i className={"sp-menu-icon"} />
            </div>
          </div>
          {title ? (
            <div className="sp-name">{title}</div>
          ) : (
            <i className="sp-logo" />
          )}
          <div className="flex-row-vertical-center sp-menu-right">
            {pathname !== url.search && (
              <div
                className="sp-search-button"
                onClick={this.handleSearch}
                tabIndex="0"
              />
            )}
          </div>
        </header>
        {authState === authStateEnum.web && (
          <div className="blue-bar">{i18n.t("TCMS01002_blue_tip")}</div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headerInfo: state?.user?.headerInfo,
    authState: state?.user?.authState,
    // 課金-ADD-START
    contractInfo: state?.user?.contractInfo,
    // 課金-ADD-END
    informationBadgeStatus: state?.user?.informationBadgeStatus,
    title: state?.config?.navigationMobileTitle,
    mode: state?.config?.mode,
  };
};

export default withRouter(connect(mapStateToProps)(Header));
